import { useLocalSearchParams } from 'expo-router'

import { EVENT_ORIGIN } from '@/src/features/community/models/community.constants'
import { CommunityPublicationsScreen } from '@/src/features/community/ui/screens/CommunityPublicationsScreen'
import type { TEventOriginParam } from '@/src/general/constants/routes'

const CommunityPublicationsRouterPage = () => {
  const { id, origin = EVENT_ORIGIN.UNDEFINED } = useLocalSearchParams<{ id: string } & Partial<TEventOriginParam>>()

  return <CommunityPublicationsScreen id={parseInt(id, 10)} origin={origin} />
}

export default CommunityPublicationsRouterPage
